module.exports = __webpack_public_path__ + "img/logo_dark.c2c9bfff.svg";